module.exports = __webpack_public_path__ + "static/media/gsurvey_top.95c2e057.png";